/** Environment override for selecting one named OAuth account slot. */
export const OAUTH_ACCOUNT_ENV = 'CLODEX_OAUTH_ACCOUNT';
